import { browser } from "$app/environment"
import { localStorageStore } from "../local-storage-store"

export const darkMode = localStorageStore<boolean | null>(
  "darkMode",
  browser ? window.matchMedia("(prefers-color-scheme: dark)").matches : null,
  {
    serializer: {
      parse: (v: string) =>
        v === "true" ? true : v === "false" ? false : null,
      stringify: (v: boolean) => v.toString(),
    },
  }
)

export function toggleDarkMode() {
  darkMode.update((v) => !v)
}

if (browser) {
  darkMode.subscribe((isDark) => {
    document.body.classList.toggle("dark", isDark as boolean)
  })
}
